import { Record } from 'immutable';
export const Draft = Record({
  version: 0,
  timestamp: 0,
  id: '',
  data: null
}, 'Draft');